import React from "react";
// import {Modal, Button} from "react-bootstrap";
import NextButton from '../nextButton';

import './style.css';

          {/* {caption} */}

const OKModal = (props) => {
    const {show, closeModal, caption, messNext, img} = props;
    if (!show)
      return null;

    return (
      <>
        <div className="modal">
          <div className="modal-text-block">{caption}</div>
          <NextButton onNextLevel={closeModal} messNext={messNext} />        
          <img src={img} loading="lazy" alt="" className="modal-image"/>
        </div>

        <div className="modal-bg" onClick={closeModal}/>
      </> 

    );
  }

export default OKModal;
